module.exports = __webpack_public_path__ + "img/tilt_3.f4561d86.jpg";